export default "__VITE_ASSET__D_WVWh3d__"